// @flow

import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

import { getEnvironmentVariable, ACCEPT_COOKIE } from "../../utils/environment";

import { ModalLauncher } from "../../index";
import ModalContent from "./ModalContent";

const USER_AGREEMENT_COOKIE = getEnvironmentVariable(ACCEPT_COOKIE);

type AcceptCookiesModalProps = {
  closeBtnVisible: boolean
};

const AcceptCookiesModal = ({ closeBtnVisible }: AcceptCookiesModalProps) => {
  const [agreementCookie, setAgreementCookie] = useState(undefined);

  useEffect(() => {
    const cookie = Cookies.get(USER_AGREEMENT_COOKIE);

    setAgreementCookie(cookie);
  }, []);

  const setAgreement = (userDecision: string, closeModal: () => {}): void => {
    Cookies.set(USER_AGREEMENT_COOKIE, userDecision, { expires: 365 });

    if (userDecision === "false") return closeModal();

    return window.location.reload();
  };

  return (
    !agreementCookie && (
      <ModalLauncher
        closeBtnVisible={closeBtnVisible}
        isOpen
        content={({ close }) => (
          <ModalContent setAgreement={userDecision => setAgreement(userDecision, close)} />
        )}
      />
    )
  );
};

export default AcceptCookiesModal;
